import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Copyright from './Copyright';
import logo from './assets/images/st.png';
import FooterLinks from './FooterLinks';
// TODO remove, this demo shouldn't need to reset the theme.

export default function StickyFooter() {
  return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '15vh',
          width: '100%'
        }}
      >
        <CssBaseline />
        <Box
          component="footer"
          sx={{
            py: 3,
            px: 2,
            mt: 'auto',
            width: '100%',
            align: "center",
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[200]
                : theme.palette.grey[800],
          }}
        >
          <Container maxWidth="sm">
          <Typography variant="h6" align="center" gutterBottom>
          <img src={logo} alt="logo" width={85} />
      </Typography>
            <Typography align="center" variant="body1">
              <FooterLinks />
            </Typography>
            <Copyright />
          </Container>
        </Box>
      </Box>
  );
}